import { CardOutlined } from '@/src/assets/icons/CardOutlined'
import { CardBenefitsTab } from '@/src/experiences/card-benefits/navigation/tab'
import { RewardsTab } from '@/src/experiences/rewards/navigation/tab'
import { HomeTab } from '@/src/experiences/home/navigation/tab'
import { Tabs } from 'expo-router'
import type { ComponentProps } from 'react'

type TabsScreenProps = Exclude<
  NonNullable<ComponentProps<typeof Tabs.Screen>['options']>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (...args: any[]) => any
>

export type TabsDefinition = Record<
  string,
  Pick<TabsScreenProps, 'title'> &
    Pick<ComponentProps<typeof Tabs.Screen>, 'name' | 'options'> & { Icon: React.FC } & Pick<
      TabsScreenProps,
      'href'
    >
>

export const tabs = {
  ...HomeTab,
  card: {
    name: 'card',
    title: 'Mesa Card',
    Icon: CardOutlined,
    href: `/main/(tabs)/card`,
    options: {},
  },
  ...CardBenefitsTab,
  ...RewardsTab,
} as const satisfies TabsDefinition

tabs satisfies { [tabKey in keyof typeof tabs]: { name: tabKey; href: `/main/(tabs)/${tabKey}` } }

// ensure the tab name _is_ the tab key
tabs satisfies { [tabKey in keyof typeof tabs]: { name: tabKey } }

export const tabsList = Object.values(tabs)
